<div fxLayout="row" fxLayoutAlign="center center" class="naturaImg">
  <img src="../assets/natura-logo.svg" width="100%" style="max-width: 350px; " />
</div>
<br /><br /><br />
<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">
  <mat-card class="box">
    <mat-card-header>
      <div align="left">
        <h2>Restablecer contraseña</h2>
      </div>
    </mat-card-header>
    <form class="example-form">
      <mat-card-content>
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Código de consultor" [(ngModel)]="id" name="id" required>
        </mat-form-field>
        <mat-form-field class="example-full-width {{ (documentRequired.toString() == 'false' ? 'displaynone' : '') }}" >
          <input matInput placeholder="Documento" [(ngModel)]="document" name="document" [required]="documentRequired" >
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Fecha de nacimiento" [textMask]="{mask: datemask}" [(ngModel)]="date"
            name="date" required>
        </mat-form-field>
      </mat-card-content>
    </form>
  </mat-card>
</div>
<br /><br />
<div fxLayout="row" fxLayoutAlign="center center">
  <button mat-stroked-button color="" (click)="backUrl()"
     class="button-back"> <mat-icon>arrow_back</mat-icon>
    </button>
  <button mat-stroked-button color="" (click)="openDialog()"
    [disabled]="((id == '') || (document == '' && documentRequired.toString() == 'true') || (date ==  ''))  ? true : false" class="button-send">VALIDAR DATOS</button>
</div>
<br />
<div fxLayout="row" fxLayoutAlign="center center">
  <img src="../assets/powered by Gera.svg" width="100%" style="max-width: 150px; position: relative;" />
</div>